module.exports = __webpack_public_path__ + "img/introduce3.9303a54c.png";